export var TABLE_INIT_REQUEST = 'TABLE_INIT_REQUEST';
export var TABLE_INIT = 'TABLE_INIT';
export var TABLE_SUCCESS_REQUEST = 'TABLE_SUCCESS_REQUEST';
export var TABLE_UPDATE_REQUEST = 'TABLE_UPDATE_REQUEST';
export var TABLE_UPDATE = 'TABLE_UPDATE';
export var TABLE_CLOSE_REQUEST = 'TABLE_CLOSE_REQUEST';
export var TABLE_CLOSE = 'TABLE_CLOSE';
export var TABLE_CLOSE_ALL_REQUEST = 'TABLE_CLOSE_ALL_REQUEST';
export var TABLE_CLOSE_ALL = 'TABLE_CLOSE_ALL';
export var TABLE_API_FETCH = 'TABLE_API_FETCH';
export var TABLE_API_SUCCESS = 'TABLE_API_SUCCESS';
export var TABLE_API_FAILURE = 'TABLE_API_FAILURE';
export var TABLE_API_UPDATE = 'TABLE_API_UPDATE';